import { Moment } from 'moment';
import { Pager } from '@/store/pager.types'
import { Sort } from '@/store/sort.types'
import {
  University, Semester, Campus, Level, SpecialConsideration as MasterSpecialConsideration,
} from '@/store/master/types';
import { periodType, weekdayKey } from '@/store/common.types';
import { Group } from '@/store/groups/types';

export interface StudentsState {
  students: Student[];
  courseHistories: {
    studentId: string
    histories: CourseHistory[]
  }[]
  courseGrades: {
    studentId: string
    courseHistoryId: string
    courseGrade: CourseGrade
  }[]
  pager: Pager;
  conditions?: StudentConditions;
  sort?: Sort;
}

export enum NoExperienceWetec {
  Experience = 0,
  Yet = 1,
}

export interface StudentConditions {
  fiscalYear?: number|null
  semester?: Semester|null
  university?: University|null
  studentNumber?: string|null
  studentNameJapanese?: string|null
  studentName?: string|null
  email?: string|null
  courseName?: string|null
  levels?: Level[]
  dayOfWeeks?: weekdayKey[]
  periods?: periodType[]
  tutorId?: string|null
  tutorName?: string|null
  campuses?: Campus[]
  classroom?: string|null
  booth?: string|null
  specialConsideration?: MasterSpecialConsideration|null
  oldStudentNumber?: string|null
  studentIds?: string[]
  isSpir?: boolean
  isChangeGrade?: boolean
  wetecId?: string
  hasNotWetecId?: boolean
  absencesCount?: number|null
}

export interface Student {
  id: string,
  studentNumber: string,
  oldStudentNumber: string,
  name: string,
  nameJp: string,
  nickname: string,
  email1: string,
  email2?: string,
  phone1: string,
  phone2?: string,
  studentStatus: studentStatusCode,
  courseHistories?: CourseHistory[],
  spirHistories?: SpirHistory[],
  wetecHistories?: WetecHistory[],
  gradeHistories?: GradeHistory[],
  courseCodes?: string[],
}

export interface CourseHistory {
  no: number
  courseHistoryId: string
  courseName: string
  specialConsiderations: SpecialConsideration[]
  wetecBefore: number,
  wetecAfter: number,
}

export interface CourseGrade {
  course: {
    id: string
    name: string
  }
  rawScore: string
  groups: Group[]
  specialConsiderations: SpecialConsideration[]
  lessonStudentGrades: LessonStudentGrade[]
  finalReviewSheets: FinalReviewSheet[]
}

export interface LessonStudentGrade {
  lessonId: string
  unit: string
  preparation: number
  date: Moment
  period: periodType
  points: Point[]
  beforeComment: string|null
  comment: string
  tutor: {
    id: string
    name: string
  }
}

export interface Point {
  rubricId: string
  ratingId: string
  name: string
  description: string
  beforeDescription: string|null
  point?: number
  note: string
}

export interface FinalReviewSheet {
  tutor: {
    id: string
    name: string
  }
  beforeComment: string|null
  comment: string
}

export interface SpirHistory {
  no: number
  applicationId: string
  fromCourseHistoryId: string
  fromCourseName: string
  toCourseHistoryId: string
  toCourseName: string
}
export interface WetecHistory {
  no: number
  name: string
  wetec: Wetec
}
export interface GradeHistory {
  no: number
  applicationId: string
  courseHistoryId: string
  courseName: string
  lessonUnit: number
}
export interface SpecialConsideration {
  specialConsideration: MasterSpecialConsideration|null
  comment: string
}
export interface Wetec {
  total: number
  first: number
  second: number
  third: number
  fourth: number
  fifth: number
  sixth: number
}

export const StudentStatus = {
  1: '在学',
  2: '卒業生',
  3: '休学',
  4: '退学',
}

export type studentStatusCode = keyof typeof StudentStatus
